/* eslint-disable no-param-reassign */
import React from 'react';
import defaultActionComponents from './shared/productActionComponents';
import type { IProductActionButton, IProductActionTrackingContext, ProductActionParams } from './shared/types';

export default function ProductActionRenderer({
    model,
    overriddenActionComponents,
    ...restProps
}: IProductActionButton) {
    const { trackingContext, isSubscribable, isSubscriptionContext } = model;

    const mergedActionComponents = { ...defaultActionComponents, ...overriddenActionComponents };

    if (isSubscribable && isSubscriptionContext) {
        model.action = 'Subscribe';
    }

    // Get the Button we need to render
    const componentToRender = mergedActionComponents[model.action];

    // Prepare the props for the button
    const componentProps = {
        params: model,
        trackingInfo: trackingContext,
        ...restProps
    };

    if (!componentToRender) {
        console.error('unsupported product action');
        return null;
    }

    // create the button element with the appropriate props we prepared.
    return React.createElement<{
        params: ProductActionParams;
        trackingInfo: IProductActionTrackingContext;
    }>(componentToRender, componentProps);
}
